import { ScopeSelectKeys } from 'legacy/lut/components/widgets/public/partner360/composedReport'
import { selectScopeSelectValue } from 'legacy/lut/features/partner360/composedReport'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { Static } from 'core-components/types'
import MeasureController from 'core/analytics/MeasureController'
import { Crud } from 'core/types/Crud'
import { SimplePartnerTable } from 'partner360/components/simplePartnerTable'

import { TRANSLATION_KEYS } from '../../../../translations/TRANSLATION_KEYS'

import { extraScopeTableColumns } from './configs'
import { useScope } from './hooks/useScope'
import { GlobalEntitiesSelect } from './partnersSelect/globalEntitiesSelect/GlobalEntitiesSelect'
import { GlobalPartnersSelect } from './partnersSelect/GlobalPartnersSelect'
import { PartnersSelect } from './partnersSelect/PartnersSelect'
import { PasteFromClipboard } from './pasteFromClipboard/PasteFromClipboard'

import styles from './ScopeSection.module.scss'

interface IProps {
  metrics: MeasureController
}

export const ScopeSection = ({ metrics }: IProps) => {
  const scopeSelectValue = useSelector(selectScopeSelectValue)

  const {
    openAddToScopeModal,
    showPartnersList,
    partnersInScope,
    showGlobalPartnersList,
    onDeletePartnerFromScope,
    closeAddToScopeModal,
    onClearScope,
    openPasteFromClipboardModal,
    closePasteFromClipboardModal,
    showPasteFromClipboard,
    showGlobalPartnersListForSelectEntities,
    openAddToScopeFromGlobalModal,
    closeAddToScopeFromGlobalModal,
    closeAddGlobalPartnersToScopeModal,
  } = useScope()

  const partnersInScopeCrud = useMemo(() => {
    return new Crud({
      fetcher: new Static(partnersInScope),
      keyField: 'PartnerID',
    })
  }, [partnersInScope])

  if (scopeSelectValue === ScopeSelectKeys.ManualGlobal) {
    return (
      <GlobalPartnersSelect
        show={showGlobalPartnersList}
        onClose={closeAddGlobalPartnersToScopeModal}
      />
    )
  }

  return (
    <div>
      <div className={styles.scopeDescription}>
        <Translation text={TRANSLATION_KEYS.scopeDescription} />
      </div>
      <div className={styles.btns}>
        <Button className={styles.btns__btn} onClick={openAddToScopeModal}>
          <Translation text={TRANSLATION_KEYS.addToScope} />
        </Button>
        <Button className={styles.btns__btn} onClick={openAddToScopeFromGlobalModal}>
          <Translation text={TRANSLATION_KEYS.addToScopeFromGroup} />
        </Button>
        <Button className={styles.btns__btn} onClick={openPasteFromClipboardModal}>
          <Translation text={TRANSLATION_KEYS.openPasteFromClipboard} />
        </Button>
        <Button className={styles.btns__btn} color={'danger'} onClick={onClearScope}>
          <Translation text={TRANSLATION_KEYS.clearScope} />
        </Button>
      </div>

      <SimplePartnerTable
        sourceKey={'composed-report-partners-scope-list'}
        onDelete={onDeletePartnerFromScope}
        source={partnersInScopeCrud}
        extraColumns={extraScopeTableColumns}
      />

      <PartnersSelect show={showPartnersList} onClose={closeAddToScopeModal} />
      <GlobalEntitiesSelect
        show={showGlobalPartnersListForSelectEntities}
        onClose={closeAddToScopeFromGlobalModal}
        metrics={metrics}
      />
      <PasteFromClipboard show={showPasteFromClipboard} onClose={closePasteFromClipboardModal} />
    </div>
  )
}
